/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SharedBottomModule_bottomModule = ReadonlyArray<{
    readonly title: string | null;
    readonly description: string | null;
    readonly " $refType": "SharedBottomModule_bottomModule";
}>;
export type SharedBottomModule_bottomModule$data = SharedBottomModule_bottomModule;
export type SharedBottomModule_bottomModule$key = ReadonlyArray<{
    readonly " $data"?: SharedBottomModule_bottomModule$data;
    readonly " $fragmentRefs": FragmentRefs<"SharedBottomModule_bottomModule">;
}>;



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SharedBottomModule_bottomModule",
  "type": "BottomModule",
  "metadata": {
    "plural": true
  },
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "title",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "description",
      "args": null,
      "storageKey": null
    }
  ]
};
(node as any).hash = 'd60eee8068418e785b14703256e1c1ed';
export default node;
